import React from 'react'
import { IGroup } from '../../types/group'
import { useCrumbs } from './hooks'
import { Crumb } from './Crumb'
import { StyledBreadcrumbs } from './styled'

interface IBreadcrumbs {
  group: IGroup
}

export const Breadcrumbs = ({ group }: IBreadcrumbs) => {
  const crumbs = useCrumbs(group)
  return (
    <StyledBreadcrumbs className="auto-breadcrumbs">
      {crumbs.map((crumb, i) => (
        <Crumb key={crumb.text} item={crumb} isLast={i === crumbs.length - 1} />
      ))}
    </StyledBreadcrumbs>
  )
}
